import type { PrepaymentProviders } from '@jane/shared-ecomm/providers';
import type { JanePayIntegration } from '@jane/shared/types';

export const filterPrepaymentProviders = ({
  janePayIntegration,
  pickupMode,
  prepaymentOptions,
  reservationMode,
}: {
  janePayIntegration: JanePayIntegration | null | undefined;
  pickupMode: 'pickup' | 'curbside';
  prepaymentOptions: PrepaymentProviders[];
  reservationMode: 'delivery' | 'pickup' | 'kiosk' | 'curbside';
}): PrepaymentProviders[] => {
  const janePayReservationModes =
    janePayIntegration && janePayIntegration?.reservation_modes;

  let filteredProviders = prepaymentOptions;
  let reservationModeWithPickupMode = null;

  reservationModeWithPickupMode =
    reservationMode === 'delivery'
      ? 'delivery'
      : pickupMode === 'pickup'
        ? 'pickup'
        : 'curbside';

  if (
    janePayReservationModes &&
    !janePayReservationModes.includes(reservationModeWithPickupMode)
  ) {
    filteredProviders = filteredProviders.filter((val) => val !== 'jane_pay');
  }

  return filteredProviders;
};
